const WEBAPP_SENTRY_TUNNEL_ROUTE = "/monitoring";

const SENTRY_SAAS_DSN = /^https:\/\/[^@/]+@o(\d+)\.ingest\.([a-z]{2})\.sentry\.io\/(\d+)$/;

export function webappSentryTunnelUrl(dsn: string | undefined, webappBaseUrl: string | undefined): string | undefined {
    const saasDsn = SENTRY_SAAS_DSN.exec(dsn ?? "");
    if (saasDsn === null || !webappBaseUrl) return undefined;
    const [, orgId, regionCode, projectId] = saasDsn;
    return `${webappBaseUrl}${WEBAPP_SENTRY_TUNNEL_ROUTE}?o=${orgId}&p=${projectId}&r=${regionCode}`;
}
